import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "../service/auth.service";

@Component({
  selector: "app-user-info",
  templateUrl: "./user-info.component.html",
  styleUrls: ["./user-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class UserInfoComponent implements OnInit, OnDestroy {
  private subscription: Subscription | undefined;
  url = "https://graph.microsoft.com/v1.0/me";

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    if(authService.getIsLoggedIn()) {
      this.router.navigateByUrl('/admin')
    } else {
      this.authService.getActiveAccount();
    }
  }
  ngOnInit(): void {
    console.log('userInforComp')
    if(this.authService.getIsLoggedIn()) {
      this.router.navigateByUrl('/admin')
    } else {
      this.authService.getActiveAccount();
    }
  }
  //extremely important to unsubscribe
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
